export enum PaymentType {
    SUBSCRIPTION = 'SUBSCRIPTION',
    CREDIT = 'CREDIT',
    PLAN_UPGRADE = 'PLAN_UPGRADE',
}
